// extracted by mini-css-extract-plugin
export default {"container":"Container-module__container___XS73U","containerRes":"Container-module__containerRes___HUlZv"};